import { UMCRecordVideoController as controller } from './umc-record-video.controller';
import { UMCRecordComponent } from '../umc-record.component';

export const UMCRecordVideoComponent = {
	...UMCRecordComponent,
	controller
};
